import React, { useEffect } from 'react';
import RemoteControl from './components/RemoteControl';
import { setupPWAInstallPrompt } from './pwa';
import './assets/styles.css';

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("Service Worker registered with scope:", registration.scope);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}

const App = () => {
  useEffect(() => {
    const cleanup = setupPWAInstallPrompt();
    return cleanup; // Cleanup the event listener on unmount
  }, []);

  return (
    <div className="App">
      <h1>TV Remote Control</h1>
      <RemoteControl />
      <button id="install-button" style={{ display: 'none' }}>
        Install App
      </button>
    </div>
  );
};

export default App;